import { ReactElement } from 'react';

import { Stack } from '@mui/material';
import { FormProvider } from 'react-hook-form';

import { logger } from '@/utils';
import { Table } from '../components';
import { useManageCreditForm } from '../hooks';

export const Credits = (): ReactElement => {
  const form = useManageCreditForm();

  const handleSubmit = form.handleSubmit(
    (formData) => logger.log(formData),
    (e) => logger.log(e),
  );

  return (
    <FormProvider {...form}>
      <Stack component="form" onSubmit={handleSubmit}>
        <Table />
      </Stack>
    </FormProvider>
  );
};
